import React from 'react';

const ComingSoon = ({ title }) => {
    return (
        <div className="admin-content-v2">
            <div className="dashboard-top-nav-v2">
                <h1 className="nav-title-v2">{title}</h1>
            </div>
            <div style={{
                background: 'white',
                padding: '40px',
                borderRadius: '12px',
                textAlign: 'center',
                boxShadow: 'var(--admin-v2-card-shadow)'
            }}>
               
                <h2 style={{ color: 'var(--admin-v2-primary)', marginBottom: '10px' }}>Coming Soon</h2>
                <p style={{ color: 'var(--admin-v2-text-muted)' }}>
                    This module is currently under development. Please check back later.
                </p>
            </div>
        </div>
    );
};

export default ComingSoon;
